import { MobileSlidingContainer } from '@cian/frontend-mobile-sliding-container';
import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import { BottomNavigationContainer } from '../../containers/BottomNavigationContainer';
import { ChatContainer } from '../../containers/ChatContainer';
import { DealTypeFilterContainer } from '../../containers/DealTypeFilterContainer';
import { EntityTypeToggleContainer } from '../../containers/EntityTypeToggleContainer';
import { ErrorContainer } from '../../containers/ErrorContainer';
import { ResultsMobileContainer } from '../../containers/ResultsMobileContainer';
import { ShowMoreBtnContainer } from '../../containers/ShowMoreBtnContainer';

export const MobilePage = () => {
  return (
    <>
      <DealTypeFilterContainer />
      <EntityTypeToggleContainer />
      <ResultsMobileContainer />
      <ShowMoreBtnContainer />
      <ChatContainer />
      <ErrorContainer />
      <Responsive tablet phone>
        <MobileSlidingContainer>
          <BottomNavigationContainer />
        </MobileSlidingContainer>
      </Responsive>
    </>
  );
};
